import React, { useState } from "react";
import styled from "styled-components";
import * as Yup from "yup";
import analytics from "analytics";
import LegacyThemeProvider from "components/Layout/DefaultThemeProvider";
import { Theme } from "@literati/public-ui-shared-react";
import { Subscription } from "lib/api/subscription";
import StepLayout, { StepLayoutProps } from "components/Step/StepLayout";
import {
  getContentfulQuizStep,
  gsuSubmitAnswersDefault,
} from "components/Step/stepUtil";
import {
  ReadingLevelKey as Key,
  ReadingLevelSubmit,
  ReadingLevelValues,
  ReadingLevelValuesPartial,
} from "components/Step/stepTypes";
import GuidedSignUpLayoutReadingGrade from "components/GuidedSignUp/GuidedSignUpLayoutReadingGrade";

export const VALIDATION_SCHEMA = Yup.object().shape({
  [Key.GRADE_ADJUSTMENT]: Yup.string().required("Required."),
  [Key.GRADE_ADJUSTMENT_KEY]: Yup.string().required("Required."),
});

export const INITIAL_VALUES: ReadingLevelValues = {
  [Key.KIND]: "reading-level",
  [Key.GRADE_ADJUSTMENT]: "",
  [Key.GRADE_ADJUSTMENT_KEY]: "",
} as const;

export function getReadingLevelStep(contentfulQuizModel?: any) {
  const step = getContentfulQuizStep(contentfulQuizModel, "reader-grade");

  return step;
}

const StyledGuidedSignUpLayoutReadingGrade = styled(
  GuidedSignUpLayoutReadingGrade
)`
  padding: 2rem 0;
`;

export type StepLayoutPropsReadingLevel = Omit<
  StepLayoutProps<ReadingLevelValues>,
  "asForm" | "children" | "formId"
>;

export interface StepReadingLevelProps extends StepLayoutPropsReadingLevel {
  childName?: string;
  contentfulQuizModelParsed?: any;
  initialValues?: ReadingLevelValuesPartial;
  onSubmit: ReadingLevelSubmit;
  subscription?: Subscription;
}

export const StepReadingLevel = ({
  childName,
  contentfulQuizModelParsed,
  initialValues: initialValuesProp,
  onSubmit,
  subscription,
  ...stepLayoutProps
}: StepReadingLevelProps) => {
  const [initialValues] = useState<ReadingLevelValues>({
    ...INITIAL_VALUES,
    ...initialValuesProp,
  });

  const [step] = useState(getReadingLevelStep(contentfulQuizModelParsed));

  const handleSubmit: ReadingLevelSubmit = async (values, formikHelpers) => {
    analytics?.trackAmplitudeClickEvent("reading age and grade level", values);

    return await gsuSubmitAnswersDefault({
      contentfulQuizModel: contentfulQuizModelParsed,
      formikHelpers,
      onError: (res) => res, // @TODO
      onSubmit,
      step,
      subscription,
      values,
    });
  };

  return (
    <Theme>
      <StepLayout<ReadingLevelValues>
        asForm
        bgColor="white"
        formId="activation-step-reading-level"
        formikProps={{
          initialValues,
          onSubmit: handleSubmit,
          validationSchema: VALIDATION_SCHEMA,
        }}
        {...stepLayoutProps}
      >
        <LegacyThemeProvider>
          <StyledGuidedSignUpLayoutReadingGrade
            childName={childName}
            step={step}
          />
        </LegacyThemeProvider>
      </StepLayout>
    </Theme>
  );
};

export default StepReadingLevel;
